<template>
    <div class="results">
        <div class="result-info-msg" v-if="msg_result != null"><b :class="getVotingResultMessageClass(msg_result)">{{msg_result}}</b></div>
    </div>
</template>

<script>
    export default {
        name: "VotingResultMessage",
        data() {
            return {
                
            };
        },
        props: {
            msg_result: String,
        },
        methods: {
            getVotingResultMessageClass(item) {
                if (item === null) {
                    return "";
                }

                const itemLower = item.toLowerCase();
                const noPassedLower = this.$t('com.file.voting-result-message.no-passed').toLowerCase();

                if (itemLower.includes(noPassedLower)) {
                    return "red-color-text";
                }

                return "green-color-text";
            },
        },
    };
</script>

<style lang="scss" scoped>

    .red-color-text {
        color: #e40030;
    }

    .green-color-text {
        color: #79e563;
    }

    .result-info-msg {
        margin-top: 15px;
        font-size: 24px;
    }

    .results {
        display: flex;
        flex-wrap: wrap;
        row-gap: 10px;
        column-gap: 10px;
        justify-content: center;
    }

</style>